import { ReactElement } from 'react'
import { Box, Typography } from '@mui/material'
import RestartCourse from './RestartCourse'

type InterventionsProps = {
  userID: string
}

export default ({ userID }: InterventionsProps): ReactElement => (
  <Box>
    <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
      Interventions
    </Typography>
    <RestartCourse userID={userID} />
  </Box>
)
